var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowToTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 124,
    viewBox: "0 0 209 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 122.754C9.21491 105.696 17.1156 96.4019 32.8708 89.9558C47.0988 84.1345 64.9488 84.8265 79.8773 84.4302C98.3601 83.9397 131.825 74.6413 133.59 47.7978C134.962 26.9545 117.029 11.2043 101.813 24.9106C95.9469 30.1944 96.0431 42.1802 101.403 48.0136C107.193 54.3146 117.907 53.6386 125.047 52.3718C144.222 48.9691 149.371 24.1322 164.099 13.2907C177.858 3.16159 191.518 5.82454 206.326 11.1435C207.595 11.5989 205.064 5.79806 204.554 4.28946C202.685 -1.2409 204.453 0.773449 205.866 4.95498C206.775 7.64441 209.91 12.7984 206.313 12.715C203.719 12.6543 198.963 14.5948 196.469 15.7635",
    stroke: "#0281C5",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToTopRight);
export default __webpack_public_path__ + "static/media/arrow-to-top-right.5cf2c5dbc55287df6f0ef90e55f0ce5e.svg";
export { ForwardRef as ReactComponent };